import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6963421e284d1d0014a46b1b_1781674135805_284b604e/purple_cow_unlimited/src/app/contact/page.tsx");
